import styled, { css } from 'styled-components'
import { styleReset } from 'styles/misc'
import { mq } from 'styles/mq'
import { theme } from 'styles/theme'

export const ScrollContainer = styled.div`
  position: relative;
  height: 320vh;
`
export const SwiperContainer = styled.div`
  --nav-button-size: 4rem;

  width: 100%;
  margin: 0 auto;
  max-width: calc(var(--container-width) + 2 * var(--spacing-sm));
  max-width: calc(60rem + 2 * var(--spacing-sm));
  overflow-y: visible;
  overflow-x: clip;
  @supports not (overflow: clip) {
    overflow-x: hidden;
  }

  .swiper {
    overflow: visible;
  }
  .swiper-slide {
    padding-inline: var(--spacing-sm);
  }
  .swiper-horizontal > .swiper-pagination-bullets,
  .swiper-pagination-bullets.swiper-pagination-horizontal {
    bottom: auto;
    top: calc(100% + 3rem);
  }
  .swiper-pagination-bullet {
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
    background: #d7d7d7;
  }
  .swiper-pagination-bullet-active {
    background: #2e3a59;
  }
  .swiper-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet,
  .swiper-pagination-horizontal.swiper-pagination-bullets
    .swiper-pagination-bullet {
    margin-left: 14px;
    margin-right: 14px;
  }
`
export const SwiperCover = styled.div<{ $small?: boolean }>`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  ${(props) =>
    props.$small
      ? css`
          top: auto;
          bottom: 0;
          height: 75%;
        `
      : ''}
`
export const GraphsContainer = styled.div`
  top: var(--spacing-sm);
  position: sticky;
  padding: var(--spacing-sm);
  overflow-x: hidden;
  overflow-y: hidden;
  max-width: calc(60rem + 2 * var(--spacing-sm));
  width: 100%;
  margin: auto;

  display: flex;

  > div {
    position: relative;
    top: 0;
    width: 100%;
    flex-shrink: 0;
  }
  > div:nth-child(2) {
    left: -100%;
  }
  > div:nth-child(3) {
    left: -200%;
  }
  > div:nth-child(4) {
    left: -300%;
  }
  /*> div {
    position: absolute;
    top: var(--spacing-sm);
  }
  > div:first-child {
    position: absolute;
    top: 0;
    width: calc(100% - 2 * var(--spacing-sm));
  }
  > div:last-child {
    position: relative;
    top: 0;
    width: 100%;
  }
  @media (max-width: 592px) {
    > div:first-child {
      position: relative;
      top: 0;
      width: 100%;
    }
    > div:last-child {
      position: absolute;
      top: var(--spacing-sm);
      width: calc(100% - 2 * var(--spacing-sm));
    }
  }*/
`
export const DataWrapperContainer = styled.div`
  width: 100%;
  border-radius: 28px;
  padding: 28px;
  max-height: calc(100vh - 2 * var(--spacing-sm) - 56px);
  max-height: calc(100svh - 2 * var(--spacing-sm) - 56px);
  ${mq.smallOnly} {
    max-height: none;
  }
  overflow-y: auto;
  background: var(--Background, #ffedf4);
  ${theme.shadow()};
  opacity: 1;
`

export const DotsContainer = styled.div`
  display: flex;
  gap: 2rem;
  margin: 1rem auto;
  width: fit-content;
`
export const Dot = styled.div<{ $color: boolean }>`
  position: relative;
  width: 6px;
  height: 6px;
  border-radius: 5px;
  ${mq.medium} {
    width: 8px;
    height: 8px;
  }
  ${mq.large} {
    width: 10px;
    height: 10px;
  }
  background-color: ${(props) => (props.$color ? theme.colors.text : 'white')};
`
export const NavigationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  pointer-events: none;
  margin: 2rem auto 0;
  width: 24rem;
  z-index: 10;
`

export const NavButton = styled.button<{ $dir: 'next' | 'prev' }>`
  ${styleReset}
  width: var(--nav-button-size);
  height: var(--nav-button-size);
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: auto;
  z-index: 12;

  &::after {
    content: '';
    display: block;
    width: inherit;
    height: inherit;
    background: url("data:image/svg+xml,%3Csvg width='41' height='41' viewBox='0 0 41 41' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4.01229 3.23265C3.39955 3.78045 3.18351 4.64589 3.46867 5.41672L9.20289 20.8701L3.46905 36.3225C3.19796 37.0566 3.38005 37.8797 3.92922 38.4289L4.01251 38.5065C4.31173 38.774 4.68461 38.945 5.08252 38.9974C5.48043 39.0498 5.88489 38.981 6.24315 38.8001L38.1885 22.6522C38.8591 22.312 39.2841 21.6216 39.2856 20.8691C39.287 20.1166 38.8592 19.4319 38.1886 19.086L6.24153 2.94033C5.88379 2.75873 5.47952 2.68947 5.08171 2.74163C4.68391 2.79379 4.31114 2.96495 4.01229 3.23265Z' fill='%232E3A59' stroke='%232E3A59' stroke-width='2'/%3E%3C/svg%3E%0A")
      center center / contain no-repeat;
  }
  &:not(:disabled) {
    cursor: pointer;
  }

  &:disabled {
    &::after {
      background: url("data:image/svg+xml,%3Csvg width='41' height='41' viewBox='0 0 41 41' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4.01229 3.23265C3.39955 3.78045 3.18351 4.64589 3.46867 5.41672L9.20289 20.8701L3.46905 36.3225C3.19796 37.0566 3.38005 37.8797 3.92922 38.4289L4.01252 38.5065C4.31173 38.774 4.68461 38.945 5.08252 38.9974C5.48043 39.0498 5.88489 38.981 6.24315 38.8001L38.1885 22.6522C38.8591 22.312 39.2841 21.6216 39.2856 20.8691C39.287 20.1166 38.8592 19.4319 38.1886 19.086L6.24153 2.94033C5.88379 2.75873 5.47952 2.68947 5.08171 2.74163C4.68391 2.79379 4.31114 2.96495 4.01229 3.23265Z' stroke='%232E3A59' stroke-width='2'/%3E%3C/svg%3E%0A")
        center center / contain no-repeat;
    }
  }

  ${(props) =>
    props.$dir === 'prev' &&
    css`
      transform: rotate(180deg);
    `}
`
